module.exports = __webpack_public_path__ + "static/jfd-8ac759e143e495a0ee51f6610765d290.png";